'use strict';

/**
 * data-sw-input-threshold will trigger an event if a threshold is a met
 * 
 * data-sw-input-threshold: The threshold that must be met
 * data-sw-input-threshold-unique-id: A unique id to make sure the right event is listened too
 */

var $ = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');
var swUtils = require('js/lib/sw-utils');

var ATTRS = {
  ROOT: 'data-sw-input-threshold',
  uniqueId: 'data-sw-input-threshold-unique-id'
};

var EVENT_PREFIX = 'threshold-met-';

$(function() {
  var $body = $('body');
  var mainSelector = swUtils.makeAttributeValueSelector(ATTRS.ROOT);

  $body.on('click change', mainSelector, function eventHandler() {
    var $el = $(this);
    var threshold = parseInt($el.swDataAttr(ATTRS.ROOT), 10);
    var uniqueId = $el.swDataAttr(ATTRS.uniqueId);
    var eventName = EVENT_PREFIX + uniqueId;
    var quantity = parseInt($el.val(), 10);

    if(quantity >= threshold) {
      sw.trigger(eventName);
      $el.removeAttr(ATTRS.ROOT);
    }
  });
});
